// extracted by mini-css-extract-plugin
export default {"term":"term_term__j9Haj","Container":"term_Container__R8cSA","Title":"term_Title__D3d7C","Description":"term_Description__xDH2f"};